type Tone = "chrome" | "acid" | "wood";

type Props = {
  name?: string;
  size?: number;
  tone?: Tone;
  className?: string;
};

/**
 * Avatar — initial badge. 3 tone variants (chrome default, acid for self,
 * wood for honor/host).
 */
export function Avatar({ name = "PP", size = 36, tone = "chrome", className }: Props) {
  const bg =
    tone === "acid"
      ? "linear-gradient(135deg,#c6ff3d,#6b8c00)"
      : tone === "wood"
        ? "linear-gradient(135deg,#d4a574,#8b6440)"
        : "linear-gradient(135deg,#3a3a3a,#1a1a1a)";

  return (
    <div
      className={`inline-flex items-center justify-center font-display select-none ${className ?? ""}`}
      style={{
        width: size,
        height: size,
        borderRadius: size,
        background: bg,
        color: tone === "chrome" ? "#f5f5f5" : "#0a0a0a",
        fontStretch: "75%",
        fontVariationSettings: '"wdth" 75',
        fontSize: size * 0.42,
        fontWeight: 600,
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -2px 4px rgba(0,0,0,0.3)",
        flex: "0 0 auto",
      }}
    >
      {name.slice(0, 2).toUpperCase()}
    </div>
  );
}
